import { Modal, Radio, Switch, Button, InputNumber } from 'antd';
import { Field, Form, Formik } from 'formik';
import { Fragment } from 'react';
import { object } from 'yup';
import { DatePicker, Text } from '.';
import { SingleSelect } from './SingleSelect';
import { classNames } from 'src/utilities';
import TextArea from 'antd/es/input/TextArea';
import { AppointmentType } from 'src/components/baseComponents/AppointmentType';
import { isEmpty } from 'lodash';

const vSchema = object({});
export const TemplatesModal = ({
  open,
  sections, // Array of sections with headings and fields
  validationSchema = vSchema,
  initialValues,
  className,
  submitButtonText = 'Ok',
  cancelButtonText = 'Cancel',
  handleCancel = () => null,
  handleSubmit,
  customBody,
  additionalBody,
  loading,
  centered,
  handleRadioButton,
  radioButtonValue,
  appointmentTypes,
  closable,
}) => {
  const allAppointmentTypes = !isEmpty(appointmentTypes)
    ? [...appointmentTypes]
    : [];

  return (
    <Formik
      initialValues={{
        ...initialValues,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        resetForm,
        setFieldValue,
        values,
        setFieldTouched,
      }) => (
        <Modal
          mask={true}
          open={open}
          onCancel={handleCancel}
          closable={closable}
          afterClose={() => resetForm()}
          className={classNames(`custom-modal`, className ? className : '')}
          centered={centered}
          footer={null}
          maskClosable={false}
        >
          <div className="modal_background">
            <Form
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
            >
              {sections?.map((section, index) => (
                <div className="modal__header" key={`section-${index}`}>
                  <div className="modal__header mb-3">
                    {section.heading === 'radio_group' ? (
                      <>
                        <div className="flex">
                          {/* <div className=""> Add condition </div> */}
                          <div className="flex items-center">
                            <span className="">
                              <Radio.Group
                                onChange={(e) => {
                                  handleRadioButton(e);
                                }}
                                value={radioButtonValue}
                              >
                                {appointmentTypes.map((item) => (
                                  <AppointmentType
                                    key={item.value}
                                    item={item}
                                    appointmentTypes={allAppointmentTypes}
                                  />
                                ))}
                              </Radio.Group>
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      section.heading
                    )}
                  </div>
                  <div className="modal____body">
                    {customBody ? (
                      customBody
                    ) : (
                      <div className={section.className}>
                        {section.fields.map(
                          (
                            {
                              type,
                              name,
                              title,
                              helperTitle,
                              options,
                              placeholder,
                              onChange,
                              disabled,
                              className,
                              dropdownArrow,
                              disabledDate,
                              placement,
                              extraIcon,
                              dropdownMode,
                              inputClassName,
                              ...props
                            },
                            fieldIndex
                          ) => (
                            <Fragment key={`${name}-${fieldIndex}`}>
                              <div
                                className={`${className} modal__form-el`}
                                key={name}
                              >
                                <Text
                                  type="p"
                                  className={`modal__form-el-label mb-2 ${
                                    touched[name] && errors[name] ? 'error' : ''
                                  }`}
                                >
                                  {title}
                                </Text>

                                {type === 'datepicker' ? (
                                  <DatePicker
                                    name={name}
                                    disabledDate={disabledDate}
                                    placement={placement}
                                    className={className}
                                    placeholder={placeholder}
                                  />
                                ) : type === 'switch' ? (
                                  <Text
                                    type="label"
                                    className="modal__form-el-label mb-2"
                                  >
                                    {helperTitle}
                                    <Switch
                                      className="mx-3"
                                      key={name}
                                      defaultChecked={false}
                                      style={{ backgroundColor: '#00000040' }}
                                      onChange={(checked) => {
                                        setFieldValue(name, checked);
                                      }}
                                    />
                                  </Text>
                                ) : type === 'select' ? (
                                  <SingleSelect
                                    name={name}
                                    options={options}
                                    placeholder={placeholder}
                                    disabled={disabled}
                                    className={`single-select ${touched[name] && errors[name] ? 'error' : ''}`}
                                    popupClassName={props?.popupClassName}
                                    onChange={
                                      onChange
                                        ? (value, option) => {
                                            onChange(
                                              setFieldValue,
                                              value,
                                              option
                                            );
                                          }
                                        : () => null
                                    }
                                    value={values[name]}
                                    dropdownArrow={dropdownArrow}
                                    error={touched[name] && errors[name]}
                                    extraIcon={extraIcon}
                                    dropdownMode={dropdownMode}
                                    inputClassName={inputClassName}
                                  />
                                ) : type === 'label' ? (
                                  <div className="modal__form-el">
                                    <Text className={``}>{title}</Text>
                                  </div>
                                ) : type === 'radio' ? (
                                  <div>
                                    {options.map((option) => (
                                      <label
                                        key={option.value}
                                        className="modal__form-el-radio"
                                      >
                                        <Field
                                          type="radio"
                                          name={name}
                                          value={option.value}
                                        />
                                        {option.label}
                                      </label>
                                    ))}
                                  </div>
                                ) : type === 'modalTextArea' ? (
                                  <div
                                    className={`modal__form-el-field-textarea border rounded-xl p-2 bg-white ${
                                      touched[name] && errors[name]
                                        ? 'border-[#c70039]'
                                        : 'border-[#e5e8eb]'
                                    }`}
                                  >
                                    <TextArea
                                      name={name}
                                      placeholder={placeholder}
                                      value={values[name]}
                                      onChange={(e) =>
                                        setFieldValue(name, e.target.value)
                                      }
                                      onBlur={(e) => {
                                        if (e.target.value === '') {
                                          setFieldTouched(name, true);
                                        }
                                      }}
                                      style={{
                                        resize: 'none',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                      }}
                                      bordered={false}
                                      className={`${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      autoSize={{ minRows: 3, maxRows: 13 }}
                                    />
                                  </div>
                                ) : type === 'jsonTextArea' ? (
                                  <div
                                    className={`modal__form-el-field-Json-textarea border rounded-xl p-2 ${
                                      touched[name] && errors[name]
                                        ? 'border-[#c70039]'
                                        : 'border-[#e5e8eb]'
                                    }`}
                                  >
                                    <TextArea
                                      key={name}
                                      name={name}
                                      placeholder={placeholder}
                                      value={values[name]}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        try {
                                          JSON.parse(value);
                                          setFieldValue(name, value);
                                        } catch (err) {
                                          setFieldValue(name, value);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        const { value } = e.target;
                                        setFieldTouched(name, true);
                                        try {
                                          JSON.parse(value);
                                          setFieldValue(name, value);
                                        } catch (err) {
                                          setFieldValue(name, value);
                                        }
                                      }}
                                      style={{
                                        resize: 'none',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                      }}
                                      bordered={false}
                                      className={`modal__form-el-field-Json-textarea border rounded-xl p-2 ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      autoSize={{ minRows: 3, maxRows: 13 }}
                                    />
                                  </div>
                                ) : type === 'text' ? (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    key={name}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    value={values[name] || ''}
                                    role="presentation"
                                    autoComplete="off"
                                  />
                                ) : type === 'InputNumber' ? (
                                  <InputNumber
                                    key={name}
                                    type={type}
                                    name={name}
                                    min={0}
                                    placeholder={placeholder}
                                    bordered={false}
                                    disabled={disabled}
                                    onBlur={(e) => {
                                      if (e === '') {
                                        setFieldTouched(name, true);
                                      }
                                    }}
                                    value={values[name] || ''}
                                    onChange={
                                      onChange
                                        ? (e) => {
                                            onChange(setFieldValue, e);
                                          }
                                        : () => null
                                    }
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                  />
                                ) : type === 'number' ? (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    key={name}
                                    type={type}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    {...props}
                                    value={values[name] || ''}
                                    role="presentation"
                                    autoComplete="off"
                                  />
                                ) : (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    key={name}
                                    type={type}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    {...props}
                                    value={values[name] || null}
                                    role="presentation"
                                    autoComplete="off"
                                  />
                                )}

                                {touched[name] && errors[name] && (
                                  <Text type={'error'} className={'error'}>
                                    {errors[name]}
                                  </Text>
                                )}
                              </div>
                            </Fragment>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {additionalBody ? additionalBody : ''}
              <div className="flex justify-end gap-5 modal__form-footer">
                {cancelButtonText && (
                  <div className="">
                    <Button
                      loading={loading}
                      className="cancel-button"
                      onClick={() => handleCancel()}
                    >
                      {cancelButtonText}
                    </Button>
                  </div>
                )}
                {submitButtonText && (
                  <div className="inline-block">
                    <Button
                      className="submit-button"
                      htmlType="submit"
                      loading={loading}
                    >
                      {submitButtonText}
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </div>
        </Modal>
      )}
    </Formik>
  );
};
